var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"file-badge"},[_vm._t("file-icon",function(){return [_c('FileIcon',{staticClass:"file-icon"})]}),_c('span',{staticClass:"file-type"},[_vm._v(_vm._s(_vm.fileType))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }